import './App.css';
import HomePage from './pages/HomePage'
import DetailPage from './pages/DetailPage'
import CategoryPage from './pages/CategoryPage'
import NavigationBar from './components/NavigationBar'
import FooterBar from './components/FooterBar'
import { Routes, Route, Link } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <NavigationBar/>
      <Routes>
        <Route path="/" element={<HomePage/>}/>
        <Route path="/products" element={<CategoryPage/>}/>
        <Route path="/products/detail/:id" element={<DetailPage/>}/>
      </Routes>
      <FooterBar/>
    </div>
  );
}

export default App;
